import webStorage from "@/libs/webStorage";
// import constants from "@/libs/constants";

import base from "./base";

const authApi = dispatch => {
  return {
    async register(data) {
      const response = await base.publicApi(dispatch, {
        path: "/register",
        method: "post",
        data: data
      });
      return response;
    },

    async login(email, password) {
      const response = await base.publicApi(dispatch, {
        path: "/authen",
        method: "post",
        data: {
          email,
          password
        }
      });
      return response;
    },
    
    async login2(email, password) {
      const response = await base.publicApi(dispatch, {
        path: "/login/local",
        method: "post",
        data: {
          email,
          password
        }
      });
      return response;
    },

    async logout() {
      const refreshToken = webStorage.get("REFRESH_TOKEN");
      await base.privateApi(dispatch, {
        path: "/logoff",
        method: "post",
        data: { 
          "refreshToken": refreshToken
         }
      });
    },

    async forgotPwd(email) {
      const response = await base.publicApi(dispatch, {
        path: "/auth/password/forgot",
        method: "post",
        data: {
          'email' : email
        }
      });
      return response;
    },

    async registerActivateToken(token) {
      const response = await base.publicApi(dispatch, {
        path: "/sso",
        method: "post",
        data: {
          token: token
        }
      });
      return response;
    },

    async resetPassword(token, password) {
      const response = await base.publicApi(dispatch, {
        path: "/auth/password/reset",
        method: "post",
        data: {
          token: token,
          password: password
        }
      });
      return response;
    },

    async refreshToken() {
      const refreshToken = webStorage.get("REFRESH_TOKEN");
      const response = await base.publicApi(dispatch, {
        path: "/auth/refresh",
        method: "post",
        data: { refreshToken }
      });
      return response;
    },
    
    async payoneerAuthorize(token) {
      const response = await base.privateApi(dispatch, {
        path: "/users/payoneer-auth",
        method: "post",
        data: {
          token: token,
        }
      });
      return response;
    },
  };
};

export default authApi;
